import React, {
  useEffect,
  useState,
} from "react";

import {
  PDFDownloadLink,
} from "@react-pdf/renderer";

import {
  Button,
  Select,
} from "antd";

import {
  DownloadOutlined,
} from "@ant-design/icons";

import api from "../../../api/api";

import AdmissionDataFormPDF
  from "./AdmissionDataFormPDF";

const AdmissionDataFormDownload = () => {
  const [gradeClasses, setGradeClasses] = useState([]);
  const [selectedGradeClass, setSelectedGradeClass] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ============================================================
     FETCH GRADE CLASSES
  ============================================================ */

  const fetchGradeClasses = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        "/api/users/grade-classes/"
      );

      const data = Array.isArray(response.data)
        ? response.data
        : response.data.results || [];

      setGradeClasses(data);
    } catch (error) {
      console.error(
        "Error fetching grade classes:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  /* ============================================================
     INITIAL LOAD
  ============================================================ */

  useEffect(() => {
    fetchGradeClasses();
  }, []);

  /* ============================================================
     SELECT GRADE CLASS
  ============================================================ */

  const handleGradeClassChange = (value) => {
    const selected = gradeClasses.find(
      (item) =>
        String(item.id) === String(value)
    );

    setSelectedGradeClass(
      selected || null
    );
  };

  /* ============================================================
     GRADE CLASS NAME
  ============================================================ */

  const gradeClassName =
    selectedGradeClass?.name ||
    selectedGradeClass?.grade_name ||
    selectedGradeClass?.title ||
    `Grade-Class-${selectedGradeClass?.id || ""}`;

  /* ============================================================
     DOWNLOAD
  ============================================================ */

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 12,
        padding: 16,
        background: "#ffffff",
        borderRadius: 12,
        border: "1px solid #e5e7eb",
        boxShadow:
          "0 4px 18px rgba(0, 0, 0, 0.06)",
      }}
    >
      {/* ======================================================
          GRADE CLASS SELECTOR
      ====================================================== */}

      <Select
        value={
          selectedGradeClass?.id ||
          undefined
        }
        onChange={
          handleGradeClassChange
        }
        placeholder="Select Grade / Class"
        style={{
          minWidth: 220,
          flex: 1,
        }}
        size="large"
        showSearch
        optionFilterProp="label"
        options={gradeClasses.map(
          (item) => ({
            value: item.id,
            label:
              item.name ||
              item.grade_name ||
              item.title ||
              `Grade Class ${item.id}`,
          })
        )}
      />

      {/* ======================================================
          DOWNLOAD BUTTON

          The button only requires a grade/class to be selected.
          It does NOT check whether students exist in that class.
      ====================================================== */}

      {selectedGradeClass && (
        <PDFDownloadLink
          document={
            <AdmissionDataFormPDF
              gradeClass={
                selectedGradeClass
              }
            />
          }
          fileName={`Admission-Forms-${gradeClassName}.pdf`}
          style={{
            textDecoration: "none",
          }}
        >
          {({
            loading: pdfLoading,
          }) => (
            <Button
              type="primary"
              size="large"
              icon={
                <DownloadOutlined />
              }
              disabled={
                loading ||
                pdfLoading
              }
              loading={
                pdfLoading
              }
              style={{
                height: 42,
                borderRadius: 8,
                fontWeight: 600,
                background:
                  "#1E3A5F",
                borderColor:
                  "#1E3A5F",
              }}
            >
              {pdfLoading
                ? "Preparing PDF..."
                : "Download Admission Form"}
            </Button>
          )}
        </PDFDownloadLink>
      )}

      {/* ======================================================
          NO CLASS SELECTED
      ====================================================== */}

      {!selectedGradeClass && (
        <Button
          type="primary"
          size="large"
          icon={
            <DownloadOutlined />
          }
          disabled
          style={{
            height: 42,
            borderRadius: 8,
            fontWeight: 600,
            background:
              "#1E3A5F",
            borderColor:
              "#1E3A5F",
          }}
        >
          Download Admission Form
        </Button>
      )}
    </div>
  );
};

export default AdmissionDataFormDownload;

